import JDs from "../../JDs";

export default function NuJobsPostedJDs(props) {
  return (
    <div className="nujobspostedjds-wrapper">
       <JDs nujobsPost = {true}/>
    </div>  
  );
}
